/**
 * @generated SignedSource<<925da6cd78e864e2a6b5be2b942a9c8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PortfolioProjectTextCoverStyle = "COLOR_BLACK" | "COLOR_BLUE" | "COLOR_GREEN" | "COLOR_ORANGE" | "COLOR_PURPLE" | "COLOR_SALMON" | "COLOR_WATERMELON" | "COLOR_WHITE" | "COLOR_YELLOW" | "SHAPE_COINS_DARK" | "SHAPE_COINS_LIGHT" | "SHAPE_COLLABORATION_DARK" | "SHAPE_COLLABORATION_LIGHT" | "SHAPE_FOCUS_DARK" | "SHAPE_FOCUS_LIGHT" | "SHAPE_GAIN_DARK" | "SHAPE_GAIN_LIGHT" | "SHAPE_STAIRS_DARK" | "SHAPE_STAIRS_LIGHT" | "SHAPE_WAVE_DARK" | "SHAPE_WAVE_LIGHT" | "SVG_BLUE" | "SVG_BLUE2" | "SVG_LINES_BLUE" | "SVG_LINES_GREEN" | "SVG_LINES_ORANGE" | "SVG_LINES_PURPLE" | "SVG_LINES_SALMON" | "SVG_LINES_YELLOW" | "SVG_WHITE" | "SVG_WHITE2" | "SVG_YELLOW" | "SVG_YELLOW2" | "VAPOR_GRADIENT_BLUE_DARK" | "VAPOR_GRADIENT_BLUE_LIGHT" | "VAPOR_GRADIENT_GREEN_DARK" | "VAPOR_GRADIENT_GREEN_LIGHT" | "VAPOR_GRADIENT_PURPLE_DARK" | "VAPOR_GRADIENT_PURPLE_LIGHT" | "VAPOR_GRADIENT_SALMON_DARK" | "VAPOR_GRADIENT_SALMON_LIGHT" | "VAPOR_GRADIENT_WATERMELON_DARK" | "VAPOR_GRADIENT_WATERMELON_LIGHT" | "VAPOR_GRADIENT_WHITE_DARK" | "VAPOR_GRADIENT_YELLOW_LIGHT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectCoverWrapper_portfolioProjectCover$data = {
  readonly __typename: "PortfolioProjectImageCover";
  readonly image: {
    readonly animated: boolean;
    readonly uid: string;
  };
  readonly " $fragmentType": "ProjectCoverWrapper_portfolioProjectCover";
} | {
  readonly __typename: "PortfolioProjectTextCover";
  readonly style: PortfolioProjectTextCoverStyle;
  readonly " $fragmentType": "ProjectCoverWrapper_portfolioProjectCover";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ProjectCoverWrapper_portfolioProjectCover";
};
export type ProjectCoverWrapper_portfolioProjectCover$key = {
  readonly " $data"?: ProjectCoverWrapper_portfolioProjectCover$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectCoverWrapper_portfolioProjectCover">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectCoverWrapper_portfolioProjectCover",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ContraImage",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "animated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PortfolioProjectImageCover",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        }
      ],
      "type": "PortfolioProjectTextCover",
      "abstractKey": null
    }
  ],
  "type": "PortfolioProjectCover",
  "abstractKey": "__isPortfolioProjectCover"
};
})();

(node as any).hash = "968cd88816f13123513b15d841019126";

export default node;
